.sortButton {
  text-transform: var(--haus-sort__sortButton__text-transform, capitalize);
  border: var(--haus-sort__sortButton__border, none);
  padding: var(--haus-sort__sortButton__padding, 0);
  border-radius: var(--haus-sort__sortButton__border-radius, 0);
  background: var(--haus-sort__sortButton__background, transparent);
  color: var(--haus-sort__sortButton__color, var(--haus-color-body));
  font-family: var(--haus-sort__sortButton__font-family, var(--haus-typography-body-font-family));
  font-weight: var(--haus-sort__sortButton__font-weight, 700);
  font-size: var(--haus-sort__sortButton__font-size, 16px);
  display: var(--haus-sort__sortButton__display, inline-flex);
  align-items: var(--haus-sort__sortButton__align-items, center);
  gap: var(--haus-sort__sortButton__gap, 8px);
  cursor: var(--haus-sort__sortButton__cursor, pointer);
  white-space: var(--haus-sort__sortButton__white-space, nowrap);
  width: var(--haus-sort__sortButton__width, fit-content);

  &:hover {
    border: var(--haus-sort__sortButton__hover__border, none) !important;
    background: var(--haus-sort__sortButton__hover__background, transparent) !important;
    color: var(--haus-sort__sortButton__hover__color, var(--haus-color-body)) !important;
    font-weight: var(--haus-sort__sortButton__hover__font-weight, 700) !important;
    outline: var(--haus-sort__sortButton__hover__outline, none) !important;
  }

  &:focus-visible {
    outline: var(
      --haus-sort__sortButton__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-sort__sortButton__focus-visible__outline-offset, 2px);
  }

  .sortByLabel {
    font-weight: var(--haus-sort__sortByLabel__font-weight, 700);
  }

  .sortByValue {
    font-weight: var(--haus-sort__sortByValue__font-weight, 400);
  }
}

.dropdownContent {
  background: var(--haus-sort__dropdownContent__background, #fff);
  border: var(--haus-sort__dropdownContent__border, 1px solid #e5e7eb);
  border-radius: var(--haus-sort__dropdownContent__border-radius, 8px);
  padding: var(--haus-sort__dropdownContent__padding, 12px);
  min-width: var(--haus-sort__dropdownContent__min-width, 260px);
  z-index: var(--haus-sort__dropdownContent__z-index, 99999) !important;
  box-shadow: var(
    --haus-sort__dropdownContent__box-shadow,
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06)
  );
  position: relative;
}

.selectViewport {
  border-radius: var(--haus-sort__selectViewport__border-radius, 8px);
  max-height: var(--haus-sort__selectViewport__max-height, 500px);
  overflow: var(--haus-sort__selectViewport__overflow, auto);
  box-sizing: var(--haus-sort__selectViewport__box-sizing, border-box);
  display: var(--haus-sort__selectViewport__display, grid);
  gap: var(--haus-sort__selectViewport__gap, 10px);
}

.selectItem {
  display: var(--haus-sort__selectItem__display, flex);
  align-items: var(--haus-sort__selectItem__align-items, center);
  gap: var(--haus-sort__selectItem__gap, 10px);
  padding: var(--haus-sort__selectItem__padding, 8px);
  border-radius: var(--haus-sort__selectItem__border-radius, 8px);
  font-size: var(--haus-sort__selectItem__font-size, 14px);
  line-height: var(--haus-sort__selectItem__line-height, 1.2);
  color: var(--haus-sort__selectItem__color, var(--haus-color-body));
  font-family: var(--haus-sort__selectItem__font-family, var(--haus-typography-body-font-family));
  cursor: var(--haus-sort__selectItem__cursor, pointer);
  outline: var(--haus-sort__selectItem__outline, 2px solid transparent);

  &:hover {
    background-color: var(--haus-sort__selectItem__hover__background-color, #f6f6f6);
    border-radius: var(--haus-sort__selectItem__hover__border-radius, 8px);
    box-shadow: var(--haus-sort__selectItem__hover__box-shadow, none);
    cursor: var(--haus-sort__selectItem__hover__cursor, pointer);
    outline: var(--haus-sort__selectItem__hover__outline, none);
  }

  &[data-highlighted] {
    background-color: var(--haus-sort__selectItem__highlighted__background-color, #f6f6f6);
  }

  &:focus-visible {
    outline: var(
      --haus-sort__selectItem__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-sort__selectItem__focus-visible__outline-offset, 2px);
  }
}

.checkIconSpacer {
  width: var(--haus-sort__checkIconSpacer__width, 16px);
  height: var(--haus-sort__checkIconSpacer__height, 16px);
  flex-shrink: 0;
  display: var(--haus-sort__checkIconSpacer__display, flex);
  align-items: var(--haus-sort__checkIconSpacer__align-items, center);
  justify-content: var(--haus-sort__checkIconSpacer__justify-content, center);
}

.itemIndicator {
  display: var(--haus-sort__itemIndicator__display, flex);
  align-items: var(--haus-sort__itemIndicator__align-items, center);
  justify-content: var(--haus-sort__itemIndicator__justify-content, center);
  color: var(--haus-sort__itemIndicator__color, var(--haus-color-body));
  flex-shrink: 0;
  width: var(--haus-sort__itemIndicator__width, 16px);
  height: var(--haus-sort__itemIndicator__height, 16px);
}

.srOnly {
  position: var(--haus-sort__srOnly__position, absolute);
  width: var(--haus-sort__srOnly__width, 1px);
  height: var(--haus-sort__srOnly__height, 1px);
  padding: var(--haus-sort__srOnly__padding, 0);
  margin: var(--haus-sort__srOnly__margin, -1px);
  overflow: var(--haus-sort__srOnly__overflow, hidden);
  clip: var(--haus-sort__srOnly__clip, rect(0, 0, 0, 0));
  white-space: var(--haus-sort__srOnly__white-space, nowrap);
  border: var(--haus-sort__srOnly__border, 0);
}
